export default __webpack_public_path__ + "static/media/software.3f800625.svg";